import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Map from "../components/MapWrapper/Map/Map";
import { panelVisibilty } from "../config";
import BaseSwitcher from "./MapWrapper/BaseMap/BaseSwitcher";
import LayerDataInfo from "./MapWrapper/LayerDataInfo/LayerDataInfo";
import ToolsPanel from "../components/MapWrapper/ToolsWrapper/ToolsPanel";
import ProximityTool from "./MapWrapper/ToolsWrapper/ProximityTool";
import ProximityData from "./MapWrapper/ToolsWrapper/ProximityData";
import Timeline from "./MapWrapper/Slider/Timeline";
import TimelineHourly from "./MapWrapper/Slider/TimelineHourly";
import TimelineWgbt from "./MapWrapper/Slider/TimelineWgbt";
import { selectTools } from "../features/tools/toolsSlice";
import { selectLayerDataSet } from "../features/layers/overlaylayerslice";
import { selectMapZoomstate } from "../features/maps/mapZoomSlice";

import DowntimeModal from "../components/DowntimeModal";

const Home = () => {
  const [visibility, setVisibility] = useState(panelVisibilty);
  const [timeSteps, setTimeSteps] = useState([]);
  const [fulldatess, setfulldatess] = useState([]);
  const [id, setId] = useState(null);
  const [showTimeline, setShowTimeline] = useState(false);
  const [hourly, sethourly] = useState(false);
  const [layerDataType, setLayerDataType] = useState("");

  const [downtime, setDowntime] = useState(null);

  const overlayLayers = useSelector(selectLayerDataSet);
  const tools = useSelector(selectTools);
  const test = useSelector(selectMapZoomstate);

  // 🔥 Fetch downtime config from server
  useEffect(() => {
    fetch("/dashboard/downtime.json", { cache: "no-store" })
      .then((res) => res.json())
      .then((data) => setDowntime(data))
      .catch(() => setDowntime({ enabled: "no" }));
  }, []);

  useEffect(() => {
    const generateTimeSteps = (data) => {
      if (data.show && data.noofdays && data.class === "Model") {
        console.log("Processing layer:", data); // Debug log
        
        // Handle date string - check for different formats
        let adate;
        if (data.odate && data.odate.includes("-hr")) {
          adate = data.odate.split("-hr")[0];
        } else if (data.odate) {
          adate = data.odate;
        } else if (data.date) {
          // Try to extract date from date field
          adate = data.date.split("-hr")[0];
        } else {
          // Use current date as fallback
          adate = new Date().toISOString().split('T')[0];
        }

        console.log("Base date:", adate); // Debug log
        
        const days = [];
        const fullDate = [];

        for (let i = 0; i < data.noofdays; i++) {
          const d = new Date(adate);
          d.setDate(d.getDate() + i);

          const dayName = d.toLocaleDateString("en-US", { weekday: "short" });
          const dayNumber = d.getDate();
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const dayStr = String(dayNumber).padStart(2, "0");

          days.push(`${dayName} ${dayNumber}`);
          fullDate.push(`${year}-${month}-${dayStr}`);
        }

        setTimeSteps(days);
        setfulldatess(fullDate);
        setShowTimeline(true);
        setId(data);
        
        // Store the datatype separately for easier access
        setLayerDataType(data.datatype || "");
        
        // Check if this is hourly data
        // Fix: Add all datatypes that should use hourly timeline
        const isHourlyData = data.datatype === "acurain" || 
                            data.dataset === "regional" || 
                            data.datatype === "wbgt";
        
        console.log("Datatype:", data.datatype, "Dataset:", data.dataset, "Is Hourly:", isHourlyData); // Debug log
        
        sethourly(isHourlyData);
        
      } else if (data.show) {
        setShowTimeline(false);
        setId(null);
        setLayerDataType("");
      }
    };

    // Find the active model layer
    const activeLayer = overlayLayers?.find(layer => 
      layer.show && layer.class === "Model" && layer.noofdays
    );
    
    if (activeLayer) {
      generateTimeSteps(activeLayer);
    } else {
      setShowTimeline(false);
      setId(null);
      setLayerDataType("");
    }
  }, [overlayLayers]);

  console.log("Current state - showTimeline:", showTimeline, "hourly:", hourly, "datatype:", layerDataType, "id:", id); // Debug log

  return (
    <div>
      {/* 🔒 Permanent Downtime Modal */}
      {downtime?.enabled === "yes" && (
        <DowntimeModal message={downtime.message} />
      )}

      <LayerDataInfo />
      <BaseSwitcher />
      <Map visibility={visibility} />
      <ToolsPanel />

  

      {/* Timeline for non-hourly data (excluding WBGT) */}
      {showTimeline && !hourly && layerDataType !== "wbgt" && (
        <Timeline steps={timeSteps} data={id} fulldates={fulldatess} />
      )}

      {/* Timeline for hourly data (excluding WBGT) */}
      {showTimeline && hourly && layerDataType !== "wbgt" && (
        <TimelineHourly steps={timeSteps} data={id} fulldates={fulldatess} />
      )}

      {/* Special timeline for WBGT data */}
      {showTimeline && layerDataType === "wbgt" && (
        <TimelineWgbt steps={timeSteps} data={id} fulldates={fulldatess} />
      )}

      {tools.some((e) => e.name === "Proximity" && e.show) && (
        <ProximityTool />
      )}

      {test?.kela === "yes" && <ProximityData />}

      {tools.some((e) => e.name === "Filter" && e.show) && (
        <ProximityData />
      )}
    </div>
  );
};

export default Home;